// Intent: ONE month-grid math shared by the date picker (date-field) and the
// summary calendar — pure numbers, no strings (labels come from i18n at the
// component level, per the no-hardcoded-copy rule).

/** Monday-first weekday offset for the 1st of a month (0 = Monday). */
export function firstOffset(year: number, month: number): number {
  return (new Date(year, month, 1).getDay() + 6) % 7;
}

export function daysInMonthOf(year: number, month: number): number {
  return new Date(year, month + 1, 0).getDate();
}

/** Grid cells for a month: leading nulls (offset), then 1..daysInMonth. */
export function monthCells(year: number, month: number): (number | null)[] {
  return [...Array<null>(firstOffset(year, month)).fill(null), ...Array.from({ length: daysInMonthOf(year, month) }, (_, i) => i + 1)];
}

export function isoOf(year: number, month: number, day: number): string {
  return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
